// Farbbuttons auf Produktkarten (Kollektion, Suche, Startseite).
// Ein Listener auf document statt auf dem Produktraster: Filter, Sortierung und
// Seitenwechsel ersetzen das Raster per AJAX, der Listener bleibt trotzdem aktiv.
// Die Sperre verhindert eine doppelte Registrierung, wenn mehrere Sektionen das Skript einbinden.
(function() {
  if (window.milCardSwatchesBound) return;
  window.milCardSwatchesBound = true;

  document.addEventListener('change', function(e) {
      var input = e.target;
      if (!input.matches('input[type="radio"][data-section-id]') || !input.closest('.collection-product-card__swatch')) return;

      var sectionId = input.getAttribute('data-section-id');
      var card = input.closest('.card-product-custom-div');
      if (!card) return;

      var variantId = input.getAttribute('data-variant-id');
      var imageUrl = input.getAttribute('data-variant-media-url');
      var productUrl = input.getAttribute('data-variant-url');

      // Rückfall: Daten aus der beim Seitenaufruf erzeugten Liste der Sektion
      if (!imageUrl || !productUrl) {
          var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')] || {};
          var variantData = variantDataMap[variantId];
          if (variantData) {
              imageUrl = imageUrl || variantData.imageUrl;
              productUrl = productUrl || variantData.productUrl;
          }
      }

      if (!imageUrl) {
          console.log('No data found for variant:', variantId);
          return;
      }

      // Update the product image with lazy loading logic
      var productImageElement = card.querySelector('.card__media img');
      if (productImageElement) {
          var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
          var preloadedImage = lazyLoadAllVariants ? card.querySelector('img[data-variant-id="' + variantId + '"]') : null;
          if (preloadedImage) {
              productImageElement.src = preloadedImage.src;
              productImageElement.srcset = preloadedImage.srcset;
          } else {
              // Update src and srcset for responsive images
              // Die URLs enthalten bereits ?v=..., daher width mit & anhängen
              var sep = imageUrl.indexOf('?') === -1 ? '?' : '&';
              var dynamicSrcset = [
                  imageUrl + sep + 'width=165 165w',
                  imageUrl + sep + 'width=360 360w',
                  imageUrl + sep + 'width=533 533w',
                  imageUrl + sep + 'width=720 720w',
                  imageUrl + sep + 'width=940 940w',
                  imageUrl + sep + 'width=1066 1066w'
              ].join(', ');
              productImageElement.srcset = dynamicSrcset;
              productImageElement.src = imageUrl;
          }
      }

      // Update the product URL
      if (productUrl) {
          var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
          productLinks.forEach(function(link) {
              link.href = productUrl;
          });
      }
  });
})();
